import React from "react";

// The house icon style: a 24x24 box, no fill, `currentColor` stroke at 1.7.
// Drawing them inline rather than importing PNGs means hover and active states
// are plain CSS - the icon simply inherits the colour of whatever contains it.
export const glyph = {
  // Concentric arcs: the auction room, where bidding is broadcast live.
  live: (
    <>
      <circle cx="12" cy="12" r="2.2" />
      <path d="M8.2 15.8a5.4 5.4 0 0 1 0-7.6M15.8 8.2a5.4 5.4 0 0 1 0 7.6" />
      <path d="M5.6 18.4a9.1 9.1 0 0 1 0-12.8M18.4 5.6a9.1 9.1 0 0 1 0 12.8" />
    </>
  ),

  // A bulleted list: the player list.
  list: (
    <>
      <path d="M9 6h11M9 12h11M9 18h11" />
      <circle cx="4.6" cy="6" r="1.1" />
      <circle cx="4.6" cy="12" r="1.1" />
      <circle cx="4.6" cy="18" r="1.1" />
    </>
  ),

  // A shield: the franchises.
  teams: <path d="M12 3 5 6v5.5c0 4 2.9 7.7 7 9.5 4.1-1.8 7-5.5 7-9.5V6z" />,

  // Two people: the squad a bidder has bought.
  squad: (
    <>
      <circle cx="9" cy="8" r="3.2" />
      <path d="M3.5 19c0-3 2.5-4.8 5.5-4.8s5.5 1.8 5.5 4.8" />
      <path d="M16 5.6a3.2 3.2 0 0 1 0 6.1" />
      <path d="M17.5 14.6c2 .6 3.2 2.1 3.2 4.4" />
    </>
  ),

  // A four-square grid: the whole auction pool.
  pool: (
    <>
      <rect x="3.5" y="3.5" width="7" height="7" rx="2" />
      <rect x="13.5" y="3.5" width="7" height="7" rx="2" />
      <rect x="3.5" y="13.5" width="7" height="7" rx="2" />
      <rect x="13.5" y="13.5" width="7" height="7" rx="2" />
    </>
  ),

  // A card: the purse.
  purse: (
    <>
      <rect x="3" y="5.5" width="18" height="13" rx="3" />
      <path d="M3 10h18" />
      <circle cx="16.6" cy="14.6" r="1.2" />
    </>
  ),

  back: <path d="M15 5.5 8.5 12l6.5 6.5" />,

  close: <path d="M6.5 6.5 17.5 17.5M17.5 6.5 6.5 17.5" />,

  search: (
    <>
      <circle cx="10.8" cy="10.8" r="6.3" />
      <path d="m15.5 15.5 4 4" />
    </>
  ),

  eye: (
    <>
      <path d="M2.5 12S6 5.8 12 5.8 21.5 12 21.5 12 18 18.2 12 18.2 2.5 12 2.5 12Z" />
      <circle cx="12" cy="12" r="2.9" />
    </>
  ),

  // The same eye with a stroke through it, so showing and hiding a password
  // read as one control in two states rather than two different marks.
  eyeOff: (
    <>
      <path d="M9.9 6.1A9.6 9.6 0 0 1 12 5.8c6 0 9.5 6.2 9.5 6.2a17 17 0 0 1-2.7 3.5" />
      <path d="M6.4 8a17 17 0 0 0-3.9 4s3.5 6.2 9.5 6.2a9.4 9.4 0 0 0 3.7-.75" />
      <path d="M10 10a2.9 2.9 0 0 0 4 4" />
      <path d="m4 4 16 16" />
    </>
  ),
};

// `size` is the drawn box; the viewBox stays 24 so every glyph keeps the same
// optical weight whatever it is scaled to.
export default function Icon({ name, size = 20, strokeWidth = 1.7, ...rest }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      {...rest}
    >
      {glyph[name]}
    </svg>
  );
}
